<template>
    <zen-slide-in
        :isOpen="isOpen"
        title="Contact Support"
        :error="error"
        @close="$emit('close')"
    >
        <template #body>
            <div class="space-y-4">
                <p class="text-sm text-taupe-600">
                    Tell us what you are trying to do and we will reach out as
                    soon as possible.
                </p>

                <div>
                    <label
                        for="support-subject"
                        class="block text-sm font-medium text-taupe-900"
                    >
                        Subject
                    </label>
                    <input
                        id="support-subject"
                        :value="subject"
                        @input="$emit('update:subject', $event.target.value)"
                        type="text"
                        maxlength="140"
                        placeholder="Brief description of your issue"
                        class="mt-2 block w-full rounded-md border-0 py-2 px-3 text-taupe-900 shadow-sm ring-1 ring-inset ring-taupe-300 placeholder:text-taupe-400 focus:ring-2 focus:ring-inset focus:ring-sky-600 sm:text-sm"
                    />
                </div>

                <div>
                    <label
                        for="support-message"
                        class="block text-sm font-medium text-taupe-900"
                    >
                        Message
                    </label>
                    <textarea
                        id="support-message"
                        :value="message"
                        @input="$emit('update:message', $event.target.value)"
                        rows="6"
                        maxlength="5000"
                        placeholder="Include steps to reproduce, expected behavior, and what happened instead."
                        class="mt-2 block w-full rounded-md border-0 py-2 px-3 text-taupe-900 shadow-sm ring-1 ring-inset ring-taupe-300 placeholder:text-taupe-400 focus:ring-2 focus:ring-inset focus:ring-sky-600 sm:text-sm"
                    />
                </div>
            </div>
        </template>

        <template #buttons>
            <zen-button variant="secondary" @click="$emit('close')">
                Cancel
            </zen-button>
            <zen-button
                variant="primary"
                :processing="processing"
                data-testid="support-form-submit"
                @click="$emit('submit')"
            >
                Send Message
            </zen-button>
        </template>
    </zen-slide-in>
</template>

<script>
export default {
    name: 'ContactSupportSlideIn',
    props: {
        isOpen: {
            type: Boolean,
            required: true,
        },
        subject: {
            type: String,
            default: '',
        },
        message: {
            type: String,
            default: '',
        },
        error: {
            type: String,
            default: '',
        },
        processing: {
            type: Boolean,
            default: false,
        },
    },
    emits: ['close', 'submit', 'update:subject', 'update:message'],
}
</script>
